import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {Product} from './model';

export interface ProductState extends EntityState<Product> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'product' })
export class Store extends EntityStore<ProductState> {

  constructor() {
    super();
  }

}
